import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationCountsResponse,
  ILabReportInterpretationListParams,
  TLabReportInterpretationCounts,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationCountsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [counts, setCounts] = useState<TLabReportInterpretationCounts | null>(null);
  const [loading, setLoading] = useState(false);

  const execute = useCallback(async (params: ILabReportInterpretationListParams) => {
    const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
    setLoading(true);
    await axios
      .post(LAB_REPORT.LAB_REPORT_INTERPRETATION_COUNTS.baseURL, params, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res: AxiosResponse<ILabReportInterpretationCountsResponse>) => {
        if (res.data?.status === true) setCounts(res.data.data);
      })
      .catch((e: AxiosError) => {
        sendCurl(e.config?.["curlCommand"]);
        captureError(e);
      })
      .finally(() => setLoading(false));
  }, []);

  return { execute, counts, loading };
};
